module.exports = __webpack_public_path__ + "static/img/Andrew.b16af87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew.jpg
// module id = 7oSk
// module chunks = 0